import { render } from "./SPhorizondal.vue?vue&type=template&id=40c1e14c&scoped=true"
import script from "./SPhorizondal.vue?vue&type=script&lang=js"
export * from "./SPhorizondal.vue?vue&type=script&lang=js"

import "./SPhorizondal.vue?vue&type=style&index=0&id=40c1e14c&scoped=true&lang=css"
import "./SPhorizondal.vue?vue&type=style&index=1&id=40c1e14c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c1e14c"]])

export default __exports__